/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  if (!window.theme.settings.isConditionalPopupActive) {
    return;
  }

  // Tüm hediye ürün ID'leri
  const giftVariantIds = [
    "51495500054846", // 2500 TL itibaren hediyeler
    "51466268180798",
    "49678481948990", // 3500 TL itibaren hediyeler
    "49678477295934",
  ];

  const toKurus = (liras) => liras * 100;

  const getVariantIdFromDOM = (item) => {
    const dataItem = item.getAttribute("data-item");
    const parsedData = dataItem.split(":");

    return parsedData[0];
  };

  const getIsRemovedFromDOM = (item) => {
    return item.getAttribute("class").includes("is-removed");
  };

  const handleConditionalPopupVisibility = () => {
    // Sepette herhangi bir hediye var mı kontrolü
    const hasGiftInCart = [...cart.items].some((item) => {
      const variantId = getVariantIdFromDOM(item);
      const isRemoved = getIsRemovedFromDOM(item); // İstenildiği gibi çalışmıyor yine de kod bırakıldı.

      return !isRemoved && giftVariantIds.includes(variantId);
    });

    const totalPrice = cart.subtotal;

    if (totalPrice < toKurus(2500) || hasGiftInCart) {
      document.getElementById("popup-2500").style.display = "none";
      document.getElementById("popup-3500").style.display = "none";
    } else if (totalPrice >= toKurus(3500)) {
      document.getElementById("popup-2500").style.display = "none";
      document.getElementById("popup-3500").style.display = "block";
    } else if (totalPrice >= toKurus(2500)) {
      document.getElementById("popup-2500").style.display = "block";
      document.getElementById("popup-3500").style.display = "none";
    }

    if (!hasGiftInCart) {
      localStorage.removeItem("giftPopupDismissed");
    }
  };

  document.addEventListener("theme:cart:change", () =>
    handleConditionalPopupVisibility()
  );

  handleConditionalPopupVisibility();

  // Kapatma butonları
  document.querySelectorAll(".close-popup").forEach(function (button) {
    button.addEventListener("click", function () {
      const popupType = this.getAttribute("data-popup");
      document.getElementById(`popup-${popupType}`).style.display = "none";
      localStorage.setItem("giftPopupDismissed", "true");
    });
  });

  // Hediye ekleme butonları
  document.querySelectorAll(".add-gift").forEach(function (button) {
    button.addEventListener("click", function () {
      const popupType = this.getAttribute("data-popup");
      const variantId = parseInt(
        this.closest(".gift-item").getAttribute("data-id"),
        10
      );

      // Tüm butonları devre dışı bırak
      document
        .querySelectorAll(`#popup-${popupType} .add-gift`)
        .forEach((btn) => {
          btn.disabled = true;
          btn.textContent = "Eklendi";
        });

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      })
        .then(() => {
          localStorage.setItem("giftPopupDismissed", "true");
          document.getElementById(`popup-${popupType}`).style.display = "none";
          location.reload();
        })
        .catch((error) => {
          console.error("Hata:", error);
          document
            .querySelectorAll(`#popup-${popupType} .add-gift`)
            .forEach((btn) => {
              btn.disabled = false;
              btn.textContent = "Sepete Ekle";
            });
        });
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
